import { Factory } from 'fishery';
import { userFactory } from '@trukt/factories/userFactory';
import { accountFactory } from '@trukt/factories/accountFactory';
import { terminalFactory } from '@trukt/factories/terminalFactory';
import { integrationFactory } from '@trukt/factories/integrationFactory';
import { InvoiceSearchResponseItem } from '../services/InvoiceService';

export const invoiceSearchResponseItemFactory = Factory.define<InvoiceSearchResponseItem>(
  ({ sequence }) => ({
    dateUpdated: '2024-03-24T12:30:00Z',
    paymentTermsId: '1',
    paymentMethodId: '1',
    paymentConfig: {
      id: '1',
      fee: '3.00',
      label: 'Net 30',
    },
    caseLabels: ['Vendor Payment Hold'],
    guid: sequence.toString(),
    referenceNumber: '12345678',
    status: 'OPEN',
    total: '1200.50',
    dateTransaction: '2024-03-20T12:30:00Z',
    paymentStatus: 'RELEASED',
    datePaymentReleased: '2024-03-21T10:15:00Z',
    paymentReleasedBy: userFactory.build({
      name: 'payment user',
    }),
    client: accountFactory.build({ name: 'client account' }),
    consignee: accountFactory.build({ name: 'consignee account' }),
    logistics: {
      orderGuid: 'a1b2c3d4',
      jobGuid: 'e5f6g7h8',
      bol: '123456789-bol',
      bolUrl: 'http://example.com/bol/123456789',
      ebolURL: 'http://bol-image/3434334343',
      type: 'JOB',
      status: 'submitted',
      number: '987654321',
      classification: 'salvage',
      subClassification: 'transport',
      origin: terminalFactory.build({ street1: 'origin street' }),
      destination: terminalFactory.build({ street1: 'destination street' }),
      lotNumber: 'ABC123',
      identifier: 'DEF456',
      commodityType: 'vehicle',
      referenceNumber: 'HFUL-1',
      dateCompleted: '2022-02-22T12:30:00Z',
    },
    integrations: [
      integrationFactory.build({
        status: 'SUCCESS',
        app: {
          name: 'NETSUITE',
        },
      }),
      integrationFactory.build({
        status: 'FAILURE',
        app: { name: 'COUPA' },
      }),
    ],
  }),
);
